import { render, staticRenderFns } from "./FormattComponent.vue?vue&type=template&id=2bd053cb&functional=true"
import script from "./FormattComponent.vue?vue&type=script&lang=js"
export * from "./FormattComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports